export default class NetworkError extends Error {}

NetworkError.prototype.name = "NetworkError";
